import { useMemo } from 'react';
import { useProposalProject } from '../../../hooks/useProposalProject';
/**
 * V2-only helper: wraps `useProposalProject` and returns the response shaped
 * as a `ProjectDetail` (the form every legacy tab expects). Lets each V2
 * source page stay tiny.
 */ export function useV2ProposalProjectDetail(id) {
    const query = useProposalProject(id ?? '');
    const projectDetail = useMemo(()=>{
        if (!query.data) return null;
        const { project, members, role, memberCount } = query.data;
        return {
            projectId: project.projectId,
            name: project.name,
            description: project.description,
            type: project.type,
            status: project.status,
            createdAt: project.createdAt,
            lastActivityAt: project.lastActivityAt,
            members: members ?? [],
            role,
            memberCount
        };
    }, [
        query.data
    ]);
    return {
        projectDetail,
        isLoading: query.isLoading,
        error: query.error
    };
}
